import React from 'react';

export type RatingTag = 'S' | 'D';

interface RatingChipProps {
  tag: RatingTag;
  value: number | null | undefined;
  prominent?: boolean;
}

export function RatingChip({ tag, value, prominent }: RatingChipProps): JSX.Element {
  const present = value != null;
  const discipline = tag === 'D' ? 'debla' : 'singla';
  const className = `pac-chip pac-chip--${tag.toLowerCase()}${prominent ? ' pac-chip--prominent' : ''}${present ? '' : ' pac-chip--empty'}`;

  return (
    <span
      className={className}
      title={present ? `Ranking ${discipline}` : `Brak rankingu ${discipline}`}
    >
      <span className="pac-chip__tag">{tag}</span>
      <span className="pac-chip__value">{present ? value : '—'}</span>
    </span>
  );
}
